<template lang="pug">
    layout

        // Title
        title-component(
            :title="$t('profile.navigation[1].title')"
            slot="title"
            type="h2"
        )

        div

            // Play Payments policy: no payment management UI on Android
            subscribe-on-web(v-if="webOnly")

            template(v-else)

                // Password change form
                payment-information(v-if="showPaymentProfile")

                div(v-if="showPackagesLink && !showPaymentProfile")
                    button-component(
                        :action="navigateToPackages"
                        color="white"
                        large
                        outline
                    ) Subscribe now
</template>

<script>
    import Layout from '../Layout';
    import PaymentInformation from './PaymentInformation';
    import Button from '~components/Button';
    import SubscribeOnWeb from '~components/SubscribeOnWeb';
    import Title from '~components/Title';
    import { isAndroid } from '~services';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            Layout,
            PaymentInformation: PaymentInformation,
            TitleComponent: Title,
            ButtonComponent: Button,
            SubscribeOnWeb
        },
        computed: {
            ...mapGetters('auth', ['showPaymentProfile', 'status']),
            showPackagesLink() {
                return this.status === 'trial' || this.status === 'expired';
            },
            webOnly() {
                return isAndroid();
            }
        },
        methods: {
            navigateToPackages() {
                this.$router.push({
                    name: 'dashboard.packages'
                });
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .subscribeLink
        font-size: 20px
        text-transform: uppercase
        margin: 20px
        text-decoration: none
        color: #ffffff
</style>
